import {
  MULTI_SELECTION_ALIGN,
  MULTI_SELECTION_DISTRIBUTE,
} from './computeMultiSelectionLayoutUpdates';

/**
 * Figma-style align / distribute / group / lock shortcuts.
 * Photoshop: group ⌘G, ungroup ⌘⇧G; layer lock / (not used here — Figma ⌘⇧L).
 */
export const matchEditorLayoutShortcut = (event) => {
  const mod = event.metaKey || event.ctrlKey;
  const key = event.key?.length === 1 ? event.key.toLowerCase() : event.key;

  if (mod && !event.altKey && key === 'g') {
    if (event.shiftKey) {
      return { type: 'ungroup' };
    }
    return { type: 'group' };
  }

  if (mod && event.shiftKey && !event.altKey && (key === 'l' || key === 'L')) {
    return { type: 'toggleLock' };
  }

  if (event.altKey && !mod && !event.shiftKey) {
    const alignByKey = {
      a: MULTI_SELECTION_ALIGN.LEFT,
      d: MULTI_SELECTION_ALIGN.RIGHT,
      w: MULTI_SELECTION_ALIGN.TOP,
      s: MULTI_SELECTION_ALIGN.BOTTOM,
      h: MULTI_SELECTION_ALIGN.CENTER,
      v: MULTI_SELECTION_ALIGN.MIDDLE,
    };
    if (alignByKey[key]) {
      return { type: 'align', alignment: alignByKey[key] };
    }
  }

  // Figma: Ctrl+Alt+H / V (Mac: Control+Option — not Command)
  if (event.altKey && event.ctrlKey && !event.metaKey && !event.shiftKey) {
    if (key === 'h') {
      return { type: 'distribute', direction: MULTI_SELECTION_DISTRIBUTE.HORIZONTAL };
    }
    if (key === 'v') {
      return { type: 'distribute', direction: MULTI_SELECTION_DISTRIBUTE.VERTICAL };
    }
  }

  return null;
};

export default matchEditorLayoutShortcut;
